var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMilitaryTech(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.19922 3.14307H16.7992V10.9431C16.7992 11.3097 16.7034 11.6514 16.5117 11.9681C16.3201 12.2847 16.0576 12.5431 15.7242 12.7431L12.2742 14.7681L12.9492 17.1931H15.9742L13.4992 18.9931L14.4742 22.0431L11.9992 20.1931L9.52422 22.0431L10.4742 18.9931L8.02422 17.1931H11.0492L11.6992 14.7681L8.27422 12.7681C7.92422 12.5681 7.65755 12.3097 7.47422 11.9931C7.29089 11.6764 7.19922 11.3264 7.19922 10.9431V3.14307ZM8.32422 4.26807V10.9431C8.32422 11.1264 8.37839 11.2972 8.48672 11.4556C8.59505 11.6139 8.74089 11.7431 8.92422 11.8431L11.4992 13.2931V4.26807H8.32422ZM15.6742 4.26807H12.6492V13.2931L15.0742 11.8431C15.2576 11.7431 15.4034 11.6139 15.5117 11.4556C15.6201 11.2972 15.6742 11.1264 15.6742 10.9431V4.26807Z",
    fill: "#121619"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMilitaryTech);
export default __webpack_public_path__ + "static/media/icon_military_tech.6c653c58.svg";
export { ForwardRef as ReactComponent };